'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TooltipIcon = function TooltipIcon(props) {
  if (props.display === 'icon') {
    return _react2.default.createElement(
      'span',
      { className: 'icon-reverse icon-circle' },
      _react2.default.createElement('i', { className: 'icon-info' })
    );
  }
  return null;
};

TooltipIcon.propTypes = {
  display: _propTypes2.default.oneOf(['underline', 'icon'])
};

exports.default = TooltipIcon;